import { render, staticRenderFns } from "./organization-file-approval-survey-members-view.vue?vue&type=template&id=fb3a06b4&scoped=true"
import script from "./organization-file-approval-survey-members-view.vue?vue&type=script&lang=js"
export * from "./organization-file-approval-survey-members-view.vue?vue&type=script&lang=js"
import style0 from "./organization-file-approval-survey-members-view.vue?vue&type=style&index=0&id=fb3a06b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3a06b4",
  null
  
)

export default component.exports